// extracted by mini-css-extract-plugin
module.exports = {"rolling-text":"rolling-text_1two","notice-icon":"notice-icon_3Bce","rolling-item":"rolling-item_3yDc"};